import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { BrandLogo } from './BrandLogo';
import { trackHeaderCTA } from '../tracking';
import { scrollToLeadForm } from '../utils/scroll';
import type { Language } from '../types/lead';
export function Header() {
  const {
    t,
    lang,
    setLang
  } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleCTA = () => {
    trackHeaderCTA();
    scrollToLeadForm();
  };
  const languages: Language[] = ['en', 'es'];
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'border-b border-camel/30 bg-white/95 shadow-sm backdrop-blur-md' : 'border-b border-transparent bg-white/80 backdrop-blur-sm'}`} data-id="element-110" data-mp="36d4qn47m5oy2">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-3 px-4 py-2 sm:px-6 sm:py-3" data-id="element-111" data-mp="2wmfiwp4t3c6s">
        {/* On mobile the monogram carries the brand alone — the wordmark wrapped to two
            lines and squeezed the language toggle and CTA off the bar. */}
        <a href="#top" aria-label={t('nav.home')} className="flex items-center gap-3 font-display text-base font-extrabold uppercase leading-none tracking-[0.18em] text-ink" data-id="element-112" data-mp="2hon6i5uk33wt">
          <BrandLogo tone="light" className="h-11 w-11 sm:h-16 sm:w-16" data-id="element-113" data-mp="3adkdvdx8bgas" />
          <span className="hidden sm:inline" data-id="element-114" data-mp="35kr4uduq9lsw">MIAMI CAR QUEENS</span>
        </a>

        <div className="flex items-center gap-2 sm:gap-4" data-id="element-115" data-mp="30mpm5u17rohy">
          <div role="group" aria-label={t('nav.language')} className="flex items-center overflow-hidden border border-ink/25" data-id="element-116" data-mp="30m67cm6v1g85">
            {languages.map(code => <button key={code} type="button" onClick={() => setLang(code)} aria-pressed={lang === code} className={`min-h-[44px] px-3 text-xs font-bold uppercase leading-none tracking-[0.1em] transition-colors ${lang === code ? 'bg-ink text-white' : 'text-ink/60 hover:text-ink'}`} data-id="element-117" data-mp="3t9af2yxc88nm">
                {code}
              </button>)}
          </div>

          {/* Only ONE gold-filled CTA per viewport: while the hero (and its gold CTA)
              is on screen this stays an outline, and fills with gold after scrolling. */}
          <button type="button" onClick={handleCTA} className={`min-h-[44px] whitespace-nowrap px-3.5 text-[11px] font-bold uppercase leading-none tracking-[0.1em] transition-all sm:min-h-[48px] sm:px-5 sm:text-xs sm:tracking-[0.12em] ${scrolled ? 'bg-gold text-golddeep hover:-translate-y-[1px]' : 'border border-ink text-ink hover:bg-ink hover:text-white'}`} data-id="element-118" data-mp="yqgu1yt16fhe">
            <span className="sm:hidden" data-id="element-119" data-mp="hgcwuwrmr94s">{t('nav.ctaShort')}</span>
            <span className="hidden sm:inline" data-id="element-120" data-mp="w4hfy1ulhmo3">{t('nav.cta')}</span>
          </button>
        </div>
      </div>
    </header>;
}